"use strict";

//private
export async function _ensureNativeModuleIsInitializedWithConfiguration(nativeModule, clientId, domain, localAuthenticationOptions) {
  const hasValid = await nativeModule.hasValidAuth0InstanceWithConfiguration(clientId, domain);
  if (!hasValid) {
    await nativeModule.initializeAuth0WithConfiguration(clientId, domain, localAuthenticationOptions);
  }
}
//# sourceMappingURL=nativeHelper.js.map